export const ConsumerEmailErrorMessages = {
  general: {
    id: 'Pages.ConsumerEmail.Form.errorGeneral',
    description: 'Cannot submit email',
  },
}
